export type TransformPositionCreatedDataType = {
  OrderId: string;
  TraderPamCode: string;
  ContractIsin: string;
  Quantity: number;
  Price: number;
  TradeDate: string;
  TradeNumber: string;
  TraderDirection: number;
  Margin: number;
};

export type TransformPositionChangedDataType = {
  OrderId: string;
  TraderPamCode: string;
  ContractIsin: string;
  TradeQuantity: number;
  Price: number;
  TradeDate: string;
  TradeNumber: string;
  TraderDirection: number;
  Margin: number;
  PositionQuantity: number;
  PositionDirection: string;
};

export type TransformPositionRemovedDataType = {
  TraderPamCode: string;
  ContractIsin: string;
};

export type TransformSettlementChanged = {
  DateTime: string;
};

function transformPositionCreated(data: TransformPositionCreatedDataType) {
  const {
    OrderId: orderId,
    TraderPamCode: traderPamCode,
    ContractIsin: isin,
    Quantity: quantity,
    Price: price,
    TradeDate: tradeDate,
    TradeNumber: tradeNumber,
    TraderDirection: positionSide,
    Margin: margin,
  } = data;

  return {
    isin,
    margin,
    orderId,
    tradeDate,
    price,
    quantity,
    traderPamCode,
    tradeNumber,
    positionSide,
  };
}

function transformPositionChanged(data: TransformPositionChangedDataType) {
  const {
    OrderId: orderId,
    TraderPamCode: traderPamCode,
    ContractIsin: isin,
    TradeQuantity: tradedQuantity,
    Price: price,
    TradeDate: tradeDate,
    TradeNumber: tradeNumber,
    Margin: margin,
    PositionDirection: positionSide,
    PositionQuantity: quantity,
  } = data;

  return {
    isin,
    margin,
    orderId,
    tradeDate,
    price,
    tradedQuantity,
    traderPamCode,
    tradeNumber,
    positionSide,
    quantity,
  };
}

function transformPositionRemoved(data: TransformPositionRemovedDataType) {
  const { TraderPamCode: traderPamCode, ContractIsin: isin } = data;

  return {
    isin,
    traderPamCode,
  };
}

function transformCashSettlementChanged(data: TransformSettlementChanged) {
  const { DateTime: cashSettlementDate } = data;

  return {
    cashSettlementDate,
  };
}

function transformPhysicalSettlementChanged(data: TransformSettlementChanged) {
  const { DateTime: physicalSettlementDate } = data;

  return {
    physicalSettlementDate,
  };
}

export {
  transformPositionCreated,
  transformPositionRemoved,
  transformPositionChanged,
  transformPhysicalSettlementChanged,
  transformCashSettlementChanged,
};
